import React from "react";

export const TestCallback = () => {
  console.log("🔥 TEST CALLBACK RENDERED");
  console.log("Current URL:", window.location.href);
  console.log("Pathname:", window.location.pathname);
  console.log("Search:", window.location.search);

  return (
    <div style={{ padding: "20px", fontFamily: "monospace" }}>
      <h1>🔥 TEST CALLBACK PAGE</h1>
      <p>
        <strong>URL:</strong> {window.location.href}
      </p>
      <p>
        <strong>Pathname:</strong> {window.location.pathname}
      </p>
      <p>
        <strong>Search:</strong> {window.location.search}
      </p>
      <p>
        <strong>Timestamp:</strong> {new Date().toISOString()}
      </p>
    </div>
  );
};
